import type { ConversationSubjectUpdatedEntry } from 'lib-shared-legacy-types';

import { LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationSubjectUpdatedProps = {
  entry: ConversationSubjectUpdatedEntry;
};

export const ConversationSubjectUpdated = ({
  entry,
}: ConversationSubjectUpdatedProps): JSX.Element => {
  const { author, old_subject, new_subject } = entry;

  const authorLink = (
    <UserLink userId={author.id}>
      {author.name ?? author.email ?? author.id}
    </UserLink>
  );

  return (
    <LogEntry
      entry={entry}
      icon="pen"
      text={
        <>
          {authorLink} updated subject from &ldquo;{old_subject}&rdquo; to
          &ldquo;{new_subject}&rdquo;
        </>
      }
    />
  );
};
